<template>
    <client-page>
        <sub-visual subTab sh="About us" index="01" total="04" tabActive="회사 프로필" bg="/images/sub/visual/sv1.jpg"> </sub-visual>

        <section class="section section--first pb-0">
            <v-container>
                <div class="tit-wrap">
                    <h2 class="tit tit--lg dot-tit">회사 프로필</h2>
                </div>
            </v-container>
            <div class="cover-bg py-40 py-md-60 py-lg-90" style="background-image:url(/images/sub/aboutus/company-profile-bg.jpg);">
                <v-container>
                    <v-row>
                        <v-col cols="12" md="4" lg="4" order-md="2" offset-lg="1">
                            <div class="mb-20">
                                <v-img max-width="464" :aspect-ratio="464 / 250" src="/images/sub/aboutus/company-profile-logo.jpg" class="mx-auto mt-lg-n180" />
                            </div>
                        </v-col>
                        <v-col cols="12" md="8" lg="7" order-md="1">
                            <div class="page-text white--text">
                                <p>케이아이이 시스템즈는 다양한 산업군을 대상으로 분석기 시스템에 대한 엔지니어링 및 통합 분야에서 풍부한 경험과 노하우를 보유하고 있습니다. 이를 기반으로 고객의 요구사항에 따라 맞춤형 분석기 패키지 시스템을 제공하고 최적화된 솔루션으로 고객의 요구사항을 만족시키기 위해 항상 최선을 다합니다.</p>
                                <p>케이아이이 시스템즈의 이러한 노력은 유해한 화학물질과 가스가 포함된 다양한 산업 분야에서의 요구사항을 충족시키는데 큰 역할을 합니다.</p>
                                <p>케이아이이 시스템즈는 제품에 대한 신뢰성을 높이기 위해, 2003년부터 ISO9001인증을 보유하고 있습니다. 지속적으로 품질을 개선하고자 품질경영시스템을 도입하여 시행하고 있으며, 이를 통해 고객사에게 상당한 이점을 제공할 수 있습니다.</p>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </div>
        </section>

        <section class="section">
            <v-container>
                <div class="tit-wrap">
                    <h3 class="tit top-line-tit">산업 분야</h3>
                </div>

                <v-item-group mandatory>
                    <v-row>
                        <v-item v-for="(item, i) in items" :key="i" v-slot="{ active, toggle }">
                            <v-col cols="12" :md="active ? '6' : '2'" class="transition">
                                <v-card tile elevation="0" class="cursor-pointer" @mouseenter="toggle">
                                    <v-img cover :src="active ? item.srcOn : item.src" style="position:relative;" class="w-100 h-200px h-md-500px">
                                        <div class="w-100 h-100" :class="active ? 'd-flex' : ''">
                                            <v-overlay absolute opacity="0.4" color="#000" class="mt-auto pa-20 px-md-60 py-md-32 h-100" :class="active ? 'h-100px justify-start' : ''">
                                                <div :class="active ? 'font-size-20 font-size-md-26' : 'font-size-16 font-size-md-18 text-center'">
                                                    <div :class="{ 'd-inline-block': active }">{{ item.num }}</div>
                                                    <div class="font-weight-bold" :class="{ 'd-inline-block pl-6 pl-md-10': active }">{{ item.title }}</div>
                                                </div>
                                            </v-overlay>
                                        </div>
                                    </v-img>
                                </v-card>
                            </v-col>
                        </v-item>
                    </v-row>
                </v-item-group>
            </v-container>
        </section>

        <section class="section grey-f7">
            <v-container>
                <div class="tit-wrap">
                    <v-row>
                        <v-col cols="12" md="6">
                            <h3 class="tit top-line-tit">핵심 역량</h3>
                        </v-col>
                        <v-col cols="12" md="6">
                            <p class="page-text pt-lg-18">
                                케이아이이 시스템즈는 다양한 유형의 분석기 시스템을 설계, 엔지니어링 및 개발하는 데 핵심 역량을 갖추고 있습니다. 연구 및 엔지니어링에 대한 높은 업무 집중도를 가지고 있어 혁신적인 기술 개발에 앞장서며, 광범위한 계기 및 분석기 시스템에 대한 솔루션을 제공합니다. 케이아이이 시스템즈는 분석기 시스템 분야에서 선두에 위치하고 있습니다.
                            </p>
                        </v-col>
                    </v-row>
                </div>
            </v-container>
        </section>

        <section class="section section--last pt-0 mt-n80 mt-md-n120 mt-lg-n160">
            <v-container>
                <div class="core-competencies-slide">
                    <div class="swiper-container">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <v-row no-gutters>
                                    <v-col cols="12" lg="6">
                                        <v-card tile color="white" elevation="0" height="100%" style="potision:relative;">
                                            <div class="card-num">01</div>
                                            <div class="px-20 py-30 px-md-30 pb-md-40 px-lg-60 pb-lg-80 px-xl-120 pt-xl-90">
                                                <div class="mb-16 mb-md-24">
                                                    <h3 class="tit tit--sm">일하는 방식</h3>
                                                </div>
                                                <div class="page-text">
                                                    <p>
                                                        케이아이이 시스템즈는 변화하는 시장에 대응하기 위해 유연한 비즈니스 능력을 중요시하며, 각 지역의 요구사항을 이해하고 대응함으로써 국제적 입지를 확보하여 경쟁 우위를 유지하고 있습니다.
                                                    </p>
                                                    <p>
                                                        케이아이이 시스템즈는 최고 수준의 품질과 기술력을 유지하기 위해 제조 기술뿐만 아니라 프로세스 분석기 시스템 (Process Analyzer System)에 특화된 프로젝트 관리, 서비스 센터 및 24시간 온라인 기술지원도 제공합니다.
                                                    </p>
                                                </div>
                                            </div>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="12" lg="6">
                                        <img class="w-100" src="/images/sub/aboutus/company-profile-slide.jpg" />
                                    </v-col>
                                </v-row>
                            </div>

                            <div class="swiper-slide">
                                <v-row no-gutters>
                                    <v-col cols="12" lg="6">
                                        <v-card tile color="white" elevation="0" height="100%" style="potision:relative;">
                                            <div class="card-num">02</div>
                                            <div class="px-20 py-30 px-md-30 pb-md-40 px-lg-60 pb-lg-80 px-xl-120 pt-xl-90">
                                                <div class="mb-16 mb-md-24">
                                                    <h3 class="tit tit--sm">엔지니어링 능력</h3>
                                                </div>
                                                <div class="page-text">
                                                    <p>
                                                        케이아이이 시스템즈는 25명 이상의 엔지니어로 구성된 엔지니어 팀을 보유하고 있으며, 제조, 기술 및 서비스 전문가들이 고객의 비즈니스를 전담하여 지원합니다. 품질관리에 대한 높은 관심과 적절한 인력 배치를 통해 케이아이이 시스템즈는 항상 최상의 품질의 제품과 서비스를 제공합니다.
                                                    </p>
                                                </div>
                                            </div>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="12" lg="6">
                                        <img class="w-100" src="/images/sub/aboutus/company-profile-slide2.jpg" />
                                    </v-col>
                                </v-row>
                            </div>

                            <div class="swiper-slide">
                                <v-row no-gutters>
                                    <v-col cols="12" lg="6">
                                        <v-card tile color="white" elevation="0" height="100%" style="potision:relative;">
                                            <div class="card-num">03</div>
                                            <div class="px-20 py-30 px-md-30 pb-md-40 px-lg-60 pb-lg-80 px-xl-120 pt-xl-90">
                                                <div>
                                                    <div class="mb-16 mb-md-24">
                                                        <h3 class="tit tit--sm">생산 능력</h3>
                                                    </div>
                                                    <div class="page-text">
                                                        <v-row class="row--small">
                                                            <v-col cols="auto">·</v-col>
                                                            <v-col cols=""> 케이아이이 시스템즈는 크기가 가로 5m * 세로 3m * 높이 2.7m인 쉘터를 기준으로 연간 약 100개의 분석기 패키지 시스템을 제작할 수 있습니다. </v-col>
                                                        </v-row>
                                                        <!-- <v-row class="row--small mt-6">
                                                            <v-col cols="auto">·</v-col>
                                                            <v-col cols="">
                                                                The shelter size will be around 5mW *3mD * 2.7mH
                                                            </v-col>
                                                        </v-row> -->
                                                    </div>
                                                </div>
                                                <div class="mt-30 mt-md-46">
                                                    <div class="mb-16 mb-md-24">
                                                        <h3 class="tit tit--sm">공장 설비</h3>
                                                    </div>
                                                    <div class="page-text">
                                                        <v-row class="row--small">
                                                            <v-col cols="auto">·</v-col>
                                                            <v-col cols="">
                                                                제작동 크기 : 31mW * 32.5mD
                                                            </v-col>
                                                        </v-row>
                                                        <v-row class="row--small mt-6">
                                                            <v-col cols="auto">·</v-col>
                                                            <v-col cols="">
                                                                검사동 크기 : 15mW * 32.5mD
                                                            </v-col>
                                                        </v-row>
                                                        <v-row class="row--small mt-6">
                                                            <v-col cols="auto">·</v-col>
                                                            <v-col cols="" style="letter-spacing:-.03em !important;">
                                                                회의실 / 창고 / 사무실 / 제작 및 검사 장비
                                                            </v-col>
                                                        </v-row>
                                                    </div>
                                                </div>
                                            </div>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="12" lg="6">
                                        <img class="w-100" src="/images/sub/aboutus/company-profile-slide3.jpg" />
                                    </v-col>
                                </v-row>
                            </div>

                            <div class="swiper-slide">
                                <v-row no-gutters>
                                    <v-col cols="12" lg="6">
                                        <v-card tile color="white" elevation="0" height="100%" style="potision:relative;">
                                            <div class="card-num">04</div>
                                            <div class="px-20 py-30 px-md-30 pb-md-40 px-lg-60 pb-lg-80 px-xl-120 pt-xl-90">
                                                <div class="mb-16 mb-md-24">
                                                    <h3 class="tit tit--sm">애프터서비스</h3>
                                                </div>
                                                <div class="page-text">
                                                    <p>
                                                        케이아이이 시스템즈는 프로젝트 완료 후에도 고객에게 지속적으로 SAT, 현장 시운전 및 분석기 교육, 문제 해결(Troubleshooting) 등과 같은 서비스를 제공하며 지원합니다.
                                                    </p>
                                                </div>
                                            </div>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="12" lg="6">
                                        <img class="w-100" src="/images/sub/aboutus/company-profile-slide4.jpg" />
                                    </v-col>
                                </v-row>
                            </div>
                        </div>
                        <div class="swiper-control">
                            <v-btn icon outlined large color="grey-d" class="swiper-prev border-1 mr-6 mr-lg-10"><i class="icon icon-left-arrow-grey"></i></v-btn>
                            <v-btn icon outlined large color="grey-d" class="swiper-next border-1"><i class="icon icon-right-arrow-grey"></i></v-btn>
                        </div>
                    </div>
                </div>
            </v-container>
        </section>
    </client-page>
</template>

<script>
import Swiper from "swiper/bundle";
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
    },
    data() {
        return {
            items: [
                {
                    src: "/images/sub/aboutus/company-profile-img.jpg",
                    srcOn: "/images/sub/aboutus/company-profile-img-on.jpg",
                    num: "01",
                    title: "석유와 가스",
                },
                {
                    src: "/images/sub/aboutus/company-profile-img2.jpg",
                    srcOn: "/images/sub/aboutus/company-profile-img2-on.jpg",
                    num: "02",
                    title: "석유 화학",
                },
                {
                    src: "/images/sub/aboutus/company-profile-img3.jpg",
                    srcOn: "/images/sub/aboutus/company-profile-img3-on.jpg",
                    num: "03",
                    title: "발전소",
                },
                {
                    src: "/images/sub/aboutus/company-profile-img4.jpg",
                    srcOn: "/images/sub/aboutus/company-profile-img4-on.jpg",
                    num: "04",
                    title: "재생 에너지",
                },
            ],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {
                this.swiper = new Swiper(".core-competencies-slide .swiper-container", {
                    allowTouchMove: true,
                    centeredSlides: true,
                    spaceBetween: 0,
                    // autoplay: {
                    //     delay: 5000,
                    //     disableOnInteraction: false,
                    // },
                    speed: 500,
                    loop: true,
                    navigation: {
                        nextEl: ".swiper-next",
                        prevEl: ".swiper-prev",
                    },
                });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.core-competencies-slide {
    .swiper-control {
        top: 10px;
        left: auto;
        right: 10px;
        transform: none;
        display: inline-flex;
        align-items: center;
        width: auto;
        padding: 0;
    }
    .swiper-prev,
    .swiper-next {
        position: relative;
        top: auto;
        bottom: auto;
        left: auto;
        right: auto;
        transform: none;
        margin: 0;
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    .core-competencies-slide {
        .swiper-control {
            top: auto;
            bottom: 0;
            left: 0;
            right: auto;
        }
    }
}
@media (min-width: 1200px) {
}
</style>
